import Box, { BoxProps } from "@mui/material/Box";
import Button, { ButtonProps } from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { Form, useFormikContext } from "formik";

export const FlowForm = (props: React.ComponentProps<typeof Form>) => <StyledForm {...props} />;

export const FlowFormSubmit = (props: ButtonProps) => (
  <Button color="primary" type="submit" fullWidth data-testid="submit" {...props} />
);

export const FlowFormSubmitWrapper = (props: BoxProps) => {
  const formik = useFormikContext<Record<string, unknown>>();
  return (
    <StyledSubmitWrapper
      onClick={
        formik
          ? async () => {
              await formik.setTouched(
                Object.keys(formik.values).reduce((prev, next) => ({ ...prev, [next]: true }), {})
              );
              return formik.validateForm();
            }
          : undefined
      }
      {...props}
    />
  );
};

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 1rem;
`;

const StyledSubmitWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: end;
`;
